export const ANALYTICS_PAGE = '/analytics';
export const CLOUDFLARE_API_KB_ARTICLE_PAGE =
  'https://support.cloudflare.com/hc/en-us/articles/200167836-Where-do-I-find-my-CloudFlare-API-key-';
export const CLOUDFLARE_FORGOT_PASSWORD_PAGE =
  'https://dash.cloudflare.com/forgot-password';
export const CLOUDFLARE_SIGNUP_PAGE = 'https://dash.cloudflare.com/sign-up';
export const CLOUDFLARE_DASHBOARD_PAGE = 'https://dash.cloudflare.com/overview';
export const DOMAINS_OVERVIEW_PAGE = '/zones';
export const HOME_PAGE = '/home';
export const MORE_SETTINGS_PAGE = '/more-settings';
export const LOGIN_PAGE = '/login';
export const SIGN_UP_PAGE = '/sign-up';
export const SUPPORT_PAGE = 'https://support.cloudflare.com/hc/en-us/';
export const TERMS_AND_CONDITIONS_PAGE = 'https://www.cloudflare.com/terms';
export const PRIVACY_POLICY_PAGE = 'https://www.cloudflare.com/security-policy';
export const CLOUDFLARE_ACCOUNT_PAGE = 'https://dash.cloudflare.com/profile';
export const CLOUDFLARE_ADD_SITE_PAGE =
  'https://dash.cloudflare.com/?to=/:account/add-site';



// WEBPACK FOOTER //
// src/constants/UrlPaths.js